import { schema } from "normalizr"
import item from "./item"

export default new schema.Array(item)
